// Owner: account-settings (plan §9.3). Account › Preferences.
import { createFileRoute } from '@tanstack/react-router';
import { PreferencesPage } from '../../../features/account/PreferencesPage';

export const Route = createFileRoute('/_settings/account/preferences')({
  component: PreferencesPage,
});
